import { Theme, css, useTheme } from '@emotion/react';

import { Radius, Sizes, Spacing, Typography } from 'chatie-design-system';
import { ArrowRight, Icon } from 'chatie-design-system/icon';

const ArrowButtonCSS = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  top: 50%;
  gap: 2px;
  color: ${theme.var.gray500};

  p {
    ${Typography.body12};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0px;
  }
  i {
    margin-bottom: 0;
  }
`;

const ButtonCSS = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${theme.colors.main500};
  padding: ${Spacing.xsmall}px 10px;
  border-radius: ${Radius.small}px;

  p {
    ${Typography.body12};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0px;
    color: ${theme.var.white};
  }
`;

interface Props {
  type: 'button' | 'arrow' | 'none';
  text: string | null;
  onClickButton?: () => void;
}

const OutlookButton = ({ type, text, onClickButton }: Props) => {
  const theme = useTheme();

  if (type === 'none') {
    return <></>;
  }
  if (type === 'arrow') {
    return (
      <div css={ArrowButtonCSS} onClick={onClickButton && onClickButton}>
        {text && <p>{text}</p>}

        <Icon icon={ArrowRight} color={theme.var.gray500} size={Sizes.xsmall} />
      </div>
    );
  }
  return (
    <div css={ButtonCSS} onClick={onClickButton}>
      {text && <p>{text}</p>}
    </div>
  );
};

export default OutlookButton;
